/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { niveauActions } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_045: Question = {
  id: 'pres-045-politique-gestion-eee',
  oldId: '59',
  title: 'Intégration de la gestion des EEE dans une politique adoptée par le Conseil',
  number: '4.7',
  description: [''],
  type: QuestionType.ACTIVITY,
  frequency: 1,
  idEM: 5,
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      scoringFct: (data: string[]) => parseFloat(data[0]),
      score: '0',
      maxScore: 1,
      help: niveauActions,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

const question_pres_045__v3: Question = {
  ...question_pres_045,
  frequency: 4,
};

export const question_pres_045_v2: Question = question_pres_045;
export const question_pres_045_v3: Question = question_pres_045__v3;
